import { usePermissions } from '$hooks/actions'
import { onOneOf } from '$router/config'
import Link from '$router/Link'
import { MainSidebarMenu } from './constants'
import { MenuLinkStyle } from './styles.css'

const SidebarMenuItem = () => {
  const { checkPermissions } = usePermissions()

  return (
    <>
      {MainSidebarMenu.filter(menu => checkPermissions(menu.permissions)).map(
        (menu, key) => {
          const Icon = menu.Icon
          const isActive = onOneOf([menu.to, ...(menu.subPath ?? [])])
          return (
            <Link
              key={key}
              to={menu.to}
              options={({ params }) => ({ params })}
              className={MenuLinkStyle({ isActive })}
            >
              <Icon size={18} />
              <p>{menu.name}</p>
            </Link>
          )
        }
      )}
    </>
  )
}

export default SidebarMenuItem
